export const environment = {
  production: false,
  // baseurl: 'http://localhost:8000',
  baseurl: 'https://api-myco.cosmore.com',
  listing_baseurl: 'https://listings.cosmore.com',
};
